import { FormattedMessage } from "react-intl";

export default function CustomFooter(){
    return(
        <footer 
            className="main-footer" 
            style={{
                background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                borderTop: '2px solid rgba(102, 126, 234, 0.15)',
                padding: '20px 24px'
            }}
        >
            <div style={{ 
                display: 'flex', 
                flexWrap: 'wrap', 
                alignItems: 'center', 
                justifyContent: 'space-between',
                gap: '16px'
            }}>
                {/* Copyright Section */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: '1 1 auto' }}>
                    <strong style={{ color: '#495057' }}>
                        Copyright &copy; 2023-2024 <span style={{ 
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            fontWeight: 600
                        }}>AfriYan</span>
                    </strong>
                    <span style={{ color: '#6c757d', fontSize: '14px' }}>
                        <FormattedMessage id="tdr" />
                    </span>
                </div>

                {/* UNFPA Branding - Centered on mobile, right on desktop */}
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '8px 16px',
                    background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%)',
                    borderRadius: '8px',
                    border: '1px solid rgba(102, 126, 234, 0.15)',
                    flex: '0 0 auto'
                }}>
                    <span style={{ fontSize: '13px', color: '#666', fontWeight: 500 }}>
                        Financé par
                    </span>
                    <img 
                        src="/images/pngegg.png" 
                        alt="UNFPA Cameroun" 
                        style={{ height: '32px', objectFit: 'contain' }} 
                    />
                </div>

                {/* Version */}
                <div style={{ 
                    fontSize: '13px', 
                    color: '#6c757d',
                    flex: '0 0 auto'
                }}>
                    <b style={{ color: '#495057' }}>Version</b> 1.2.0
                </div>
            </div>
        </footer>
    );
}